
 const cartState = {
    addedProducts:[],
    totalQuantity:0,
    totalPrice:0,
    allFavouriteItems:[],
    favTotalQuantity:0,
    favTotalPrice:0,
}

export const addedItems = (state = cartState, action) => {
    let findCartProd;
    let indexCartProd;
    switch(action.type){
        case 'ADD':
            const {newProduct, quantity} = action.payload;
            const check = state.addedProducts.find(item => item.id === newProduct.id)
            
            if(check){
                
                return state;
               
            } else{
                newProduct.quantity = quantity
                
                return{
                    ...state,
                    addedProducts:[...state.addedProducts, newProduct],
                    totalQuantity:state.totalQuantity + quantity,
                    totalPrice:state.totalPrice+ quantity*newProduct.price
                    
                }
            }

            case 'ADD_NEW_PROD':
                
                const newPro = action.payload
                const checkNewPro = state.addedProducts.find(item=>item.id===newPro.id)

                   if(checkNewPro){
                       return state
                   }else{
                    newPro.quantity = 1
                    return{
                        ...state,
                        addedProducts:[...state.addedProducts,newPro],
                        totalQuantity:state.totalQuantity+newPro.quantity,
                        totalPrice:state.totalPrice+newPro.quantity*newPro.price
                    }
                   }
  

            case 'ADD_DEAL_PROD':
                const dealPro = action.payload
                const checkDeal = state.addedProducts.find(item=>item.id===dealPro.id)
                if(dealPro.quantity >1){
                    dealPro.quantity =1
                }
                if(checkDeal){
                    return state
                }else{
                    return{
                        ...state,
                        addedProducts:[...state.addedProducts,dealPro],
                        totalQuantity:state.totalQuantity+dealPro.quantity,
                        totalPrice:state.totalPrice+dealPro.quantity*dealPro.price
                    }
                }
                
                case 'INC_CART_PRO':
                    findCartProd = state.addedProducts.find(item=> item.id===action.id)
                    indexCartProd = state.addedProducts.findIndex(item=> item.id===action.id)
                    findCartProd.quantity += 1;
                    state.addedProducts[indexCartProd] = findCartProd
                    return{
                        ...state,
                        totalQuantity:state.totalQuantity+1,
                        totalPrice:state.totalPrice+findCartProd.price
                    }

                    case 'DEC_CART_PRO':
                         findCartProd = state.addedProducts.find(item=> item.id===action.id)
                         indexCartProd = state.addedProducts.findIndex(item=> item.id===action.id)
                         if(findCartProd.quantity>1){
                            findCartProd.quantity -=1
                        }else{
                            return state
                        }
                        state.addedProducts[indexCartProd] = findCartProd
                        return{
                            ...state,
                            totalQuantity:state.totalQuantity-1,
                            totalPrice:state.totalPrice - findCartProd.price
                        }


                       
                        case 'FAV_TO_CART':
                            const mainPro = action.prod;
                            const findTheProdInCart = state.addedProducts.find(item=>item.id===mainPro.id)
                            if(findTheProdInCart){
                                return state
                            }else{
                                mainPro.quantity = 1
                                return{
                                    ...state,
                                    addedProducts:[...state.addedProducts,mainPro],
                                    totalPrice:state.totalPrice+mainPro.price,
                                    totalQuantity:state.totalQuantity+1,
                                }
                            }
                        

                        case 'REMOVE_Cart':
                            const removedPro = action.payload

                            return{
                                ...state,
                                addedProducts:state.addedProducts.filter(item => item.id !== removedPro.id),
                                totalQuantity:state.totalQuantity-removedPro.quantity,
                                totalPrice:state.totalPrice-removedPro.price*removedPro.quantity
                            }

                            
                            default:
            return state;
    }
}


// ===========================================================
// ============================================================
                   /* favorite */


export const favouriteProducts = (state=cartState, action) => {
    let findPro;


    switch(action.type){
        case 'ADD_FAV':
            const favPro =  action.payload;
            const checkFavPro = state.allFavouriteItems.find(item => item.id === favPro.id)
                
                if(checkFavPro){
                    return state
                } else{
                 return{
                     ...state,
                          allFavouriteItems:[...state.allFavouriteItems,favPro],
                         favTotalQuantity:state.favTotalQuantity +1,
                         favTotalPrice:state.favTotalPrice+ favPro.quantity*favPro.price
                }
             }

                    
                    case 'REMOVE':
                        findPro = state.allFavouriteItems.find(item => item.id === action.id);

                    return{
                        ...state,
                        allFavouriteItems:state.allFavouriteItems.filter(item=>item.id!==findPro.id),
                        favTotalQuantity:state.favTotalQuantity -=1,
                        favTotalPrice:state.favTotalPrice - findPro.price
                    }
                    
                    
                    default:
                        return state
                    }
                }
               
